import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { GlobalVariable } from '../global';
import { UserApiService } from '../services/user-api.service';

@Component({
  selector: 'app-signup-friend',
  templateUrl: './signup-friend.page.html',
  styleUrls: ['./signup-friend.page.scss'],
})
export class SignupFriendPage implements OnInit {
@Input('email')email;
first_name;
last_name;
signUpForm: FormGroup;
isSubmitted=false;
formatedPhone: string;

  phone: any;
  constructor(private modalController: ModalController,
    public globals:GlobalVariable,
    public server:UserApiService,
    public fb :FormBuilder,
    ) { }

  ngOnInit() {
    this.signUpForm = this.fb.group({
      firstname: new FormControl(
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.pattern('[a-zA-Z ]*'),
        ]
      ),
      lastname: new FormControl(
        '',
       [
          Validators.required,
          Validators.minLength(2),
          Validators.pattern('[a-zA-Z ]*'),
        ]
      ),
      email: new FormControl(
        this.email,
        Validators.compose([
          Validators.required,
          Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
        ])
      ),
    
      phone: new FormControl(
        '',
         Validators.compose([Validators.required, Validators.minLength(14)])
       ),
 
    });
  }
  close(){
    this.modalController.dismiss();
    

  }
  numberChange() {
    console.log('here');
    // this.formatedPhone=''
    let elem =<HTMLIonInputElement>document.getElementById('text_input');
    // elem.focus()
    console.log(elem)
    let length=String(elem.value).length
    console.log(length)
    elem.setFocus()
    // tick()
      // elem.setSelectionRange(length,length)
    // elem.
  
    // this.phonenumber = String(phonenumber);
 
    var cleaned = (this.signUpForm.value.phone).replace(/\D/g, '');
    console.log(cleaned)
    const match = cleaned.match(/^(\d{3})(\d{0,3})(\d{0,4})$/);
    if (match) {
      // console.log(match)
      this.formatedPhone =
        '(' + match[1] + ') ' + (match[2] ? match[2] + '-' : '') + match[3];
      //  this.phonenumber= this.formatedPhone
      // console.log(this.formatedPhone);
      // let value=elem.getAttribute('value');
      // let length=elem.value.length;
      // this.input.nativeElement.setSelectionRange(length,length);
      // this.input.nativeElement.focus()
      // elem.setSelectionRange(length,length)
      // this.input.nativeElement.setFocus()
      // elem.focus()

      // console.log(elem,'dddd')
      
    }
    // var match = cleaned.match( /^(\d{3})(\d{3})(\d{4})$/)
    // if (match) {

    //     console.log('match')
    //   this.formatedPhone= '(' + match[1] + ') ' + match[2] + '-' + match[3]
    // }
    return null;
    // var clean = this.formatedPhone.replace(/[^\d]/g, '')
    // console.log(clean)
    // this.formatedPhone = clean.replace(/[0-9]{3}-[0-9]{3}-[0-9]{4}/g,'');
    // console.log(this.formatedPhone)
  }
  signUp(){
    this.isSubmitted = true;
    var cleaned = ('' + this.signUpForm.value.phone).replace(/\D/g, '');
    if (!this.signUpForm.valid) {
      console.log('Please provide all the required values!');
      return false;
    } else {
    this.globals.loader()
    this.server.customerSignUpGiftcard(this.signUpForm.value.firstname,this.signUpForm.value.lastname,this.signUpForm.value.email,'+1'+cleaned).subscribe(data=>{
      console.log(data)
      this.globals.dismiss()
      if(data.status){
      let user={
      udid:data.udid,
      first_name:this.signUpForm.value.firstname,
      last_name:this.signUpForm.value.lastname,
      email:this.signUpForm.value.email,
      }
      this.modalController.dismiss(user);
    }
    else{
      this.globals.presentToast(data.message,'middle')
    }

    },err=>{
      this.globals.dismiss()

      
    })
  }
 

  }
  get errorControl() {
    return this.signUpForm.controls;
  }
}